import React from 'react';

// ─── SkeletonBlock ──────────────────────────────────────
// <purpose>Shared shimmer placeholder for vocab-dependent chrome (Task C loading posture) — a
// consumer reading cm.configLoading renders this in place of any vocab-derived text/tiles
// while /config is still resolving.</purpose>
// <constraints>width/height are CALLER-SUPPLIED to match the real content's footprint exactly
// (UI Layout Stability Rule — nothing may shift when the real content swaps in). NEVER renders
// text: a raw `{category.…}` placeholder string is worse than an empty box, so this component
// has no text prop at all, only dimensions. The shimmer animation itself lives in index.css
// (.stx-skeleton) — prefers-reduced-motion already zeroes it globally, no local escape hatch
// needed here.</constraints>
export const SkeletonBlock: React.FC<{ width?: number | string; height: number | string; borderRadius?: number; style?: React.CSSProperties }> = ({ width = '100%', height, borderRadius = 4, style }) => (
  <div data-testid="skeleton-shimmer" aria-hidden="true" className="stx-skeleton" style={{ width, height, borderRadius, ...style }} />
);
